module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/stopnode-2acbd21100433ff49021fab1ddef1a84.svg";